<template>
  <div class="app_wrapper">
    <div class="menu">
      <div class="menu_item" v-for="(item, key) in topMenu" :key="key" :class="getMenuClass(key)">
        <span class="title">{{ item.text }}</span>
        <span class="sub_title">{{ item.sub_title }}</span>
      </div>
      <!-- <div class="menu_item dwz">
        <span class="title">点我赚</span>
        <span class="sub_title">开始赚钱</span>
      </div>
      <div class="borderline"></div>
      <div class="menu_item">
        <span class="title">快速赚</span>
        <span class="sub_title">简单快速</span>
      </div>
      <div class="borderline"></div>
      <div class="menu_item">
        <span class="title">高额赚</span>
        <span class="sub_title">奖励极高</span>
      </div>
      <div class="borderline"></div>
      <div class="menu_item">
        <span class="title">走路赚钱</span>
        <span class="sub_title">健康赚钱</span>
      </div> -->
    </div>

    <div class="top">
      <div class="my">
          <span class="txt">我的余额<i><img src="~@/assets/images/llzpreview/tips_white_withdrawal.gif" /></i></span>
          <span class="money">7.38</span>
          <span class="today">今日 +1.20</span>
      </div>
      <div class="dwz_box">
        <span class="icon">
          <div class="tips-click">
              <span>+</span>
              <b></b>
              <b></b>
              <b></b>
          </div>
          <img src="~@/assets/images/llzpreview/ic_index_zhuanqian.png" />
        </span>
        <span class="icon1">
          <img src="~@/assets/images/llzpreview/index_gif_dwz.gif" />
        </span>
        <span class="icon2">
          <span class="finger"></span>
        </span>
      </div>
      <div class="total">
        <span class="txt">累计赚取(元)</span>
        <span class="money">3430.25</span>
        <span class="coin">金币 88888<i><img src="~@/assets/images/money_icon.png" /></i></span>
      </div>
    </div>
    <div class="main">
      <div class="top_task">
        <div class="item" v-for="(item, key) in topTask" :key="key">
          <span class="text">{{ item.text }}</span>
          <span class="desp">{{ item.desp }}</span>
          <span class="icon"><img :src="item.icon" /></span>
        </div>
        <!-- <div class="item">
          <span class="text">掌上兼职</span>
          <span class="desp">赚万元现金</span>
          <span class="icon"><img src="http://game.lushihudong.com/uploads/icon/zsjziconxxhdpi.png" /></span>
        </div>
        <div class="item">
          <span class="text">小游戏</span>
          <span class="desp">PK、冲榜来赢钱</span>
          <span class="icon"><img src="http://image.lushihudong.com/llz/xyxzq_pic.png" /></span>
        </div>
        <div class="item">
          <span class="text">今日任务</span>
          <span class="desp">999+元</span>
          <span class="icon"><img src="http://image.lushihudong.com/llz/splq_pic.png" /></span>
        </div> -->
      </div>

      <div class="block m_card">
        <div class="left">
          <span class="title">
            <img src="~@/assets/images/llzpreview/ic_index_quan_icon.png" />{{ this.card.text }}
          </span>
          <span class="text">今日可用<font color="#FF7F4B">{{ this.card.num }}</font>张</span>
        </div>
        <span class="btn">立即使用 ></span>
      </div>

      <!-- <div class="block m_card">
        <div class="left">
          <span class="title">
            <img src="~@/assets/images/llzpreview/ic_index_quan_icon.png" />卡券包
          </span>
          <span class="text">今日可用<font color="#FF7F4B">2</font>张</span>
        </div>
        <span class="btn">立即使用 ></span>
      </div> -->

      <div class="block m_task">
        <div class="item" v-for="(item, key) in mTask" :key="key">
          <span class="icon"><img :src="item.icon" /></span>
          <span class="text">{{ item.text}}</span>
        </div>

        <!-- <div class="item">
          <span class="icon"><img src="http://image.lushihudong.com/llz/guanggao_splq.png" /></span>
          <span class="text">视频领钱</span>
        </div>
        <div class="item">
          <span class="icon"><img src="http://image.lushihudong.com/llz/guanggao_hjzb.png" /></span>
          <span class="text">冲榜赚400</span>
        </div>
        <div class="item">
          <span class="icon"><img src="http://image.lushihudong.com/llz/guanggao_yqhy.png" /></span>
          <span class="text">阅读拿钱</span>
        </div>
        <div class="item">
          <span class="icon"><img src="http://image.lushihudong.com/llz/guanggao_wdrw.png" /></span>
          <span class="text">我的任务</span>
        </div> -->
      </div>

      <div class="block banner">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item><img src="http://s.tn990.com/game_try/admin/20200623/20200623204049634775.png" /></van-swipe-item>
          <van-swipe-item><img src="https://s.tn990.com/llz/xsBanner.png" /></van-swipe-item>        
        </van-swipe>
      </div>

      <div class="kefu">
        <span>有问题？联系客服</span>
      </div>

      <div class="task_tab">
        <span class="active">今日推荐</span>
        <span>提现排行榜</span>
      </div>

      <div class="block task_list">
        <div class="task_item" v-for="(item, key) in taskList" :key="key">
          <div class="left">
            <span class="icon"><img :src="item.icon" /></span>
            <span class="title">{{ item.title }}</span>
            <span class="sub_title">{{ item.sub_title }}</span>
            <span class="trial_info" v-html="item.trial_info">{{ item.trial_info }}</span>
          </div>
          <div class="right">
            <span class="avg_money">{{ item.avg_money }}</span>
            <span class="btn_txt">{{ item.btn_txt }}</span>
          </div>
        </div>
      </div>

    </div>
    <div class="bottom_menu">
      <div class="bitem" v-for="(item, key) in bottomMenu" :key="key" :class="getTMenuClass(key)">
        <span class="icon" v-if="key == 0"><img :src="item.icon_check" /></span>
        <span class="icon" v-else><img :src="item.icon" /></span>
        <span class="title">{{ item.text }}</span>
      </div>
      <!-- <div class="bitem active">
        <span class="icon"><img src="http://game.lushihudong.com/uploads/icon/llzh.png" /></span>
        <span class="title">首页</span>
      </div>
      <div class="bitem">
        <span class="icon"><img src="http://game.lushihudong.com/uploads/head_img/zhuanqianh.png" /></span>
        <span class="title">高额赚</span>
      </div>
      <div class="bitem center">
        <span class="icon"><img src="http://game.lushihudong.com/uploads/icon/qdrk_xxhdpi.png" /></span>
        <span class="title">签到</span>
      </div>
      <div class="bitem">
        <span class="icon"><img src="http://game.lushihudong.com/uploads/icon/yxzh.png" /></span>
        <span class="title">邀请赚</span>
      </div>
      <div class="bitem">
        <span class="icon"><img src="http://game.lushihudong.com/uploads/head_img/wdh.png" /></span>
        <span class="title">我的</span>
      </div> -->
    </div>
    <loading :isLoad="isLoad"></loading>

  </div>
</template>

<style>
  body {
    background: #F5F7FA;
  }
</style>

<style scoped >
  .app_wrapper {
    font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑","Helvetica Neue", Helvetica, Arial, sans-serif;
  }
  
  /** 顶部菜单 */
  .menu {
    display: flex;
    width: 100%;
    height: 0.62rem;
    justify-content: center;
    align-items: center;
    background: #fff;
  }
  .menu .borderline{
    display: block;
    width: 0.01rem;
    height: 0.18rem;
    background: #EBEEF5;
    text-align: left;
  }
  .menu .menu_item {
    display: block;
    width: 0.93rem;
    text-align: center;
  }
  .menu .menu_item span {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
  }
  .menu .menu_item span.title {
    height: 0.22rem;
    line-height: 0.22rem;
    font-size: .16rem;
    color: #333;
  }
  .menu .menu_item span.sub_title {
    min-width: 0.45rem;
    margin-top: 0.04rem;
    height: 0.16rem;
    line-height: 0.16rem;
    font-size: .11rem;
    color: #999;
  }
  .menu .dwz span.title {
    color: #FF4E33;
  }
  .menu .dwz span.sub_title {
    width: 0.54rem;
    color: #fff;
    background-image: linear-gradient(to right, #FF7601 , #FF4500);
    border-radius: 0.02rem;
  }
  
  /** 顶部区域 */
  .top {
    display: flex;
    width: 100%;
    height: 2.2rem;
    padding-top: 0.2rem;
    color: #fff;
    background: url('~@/assets/images/llzpreview/ic_cpa_tasks_top_bg.png') no-repeat;
    background-size: 3.75rem 2.4rem;
    justify-content: center;
    overflow: hidden;
  }

  .top .dwz_box, .top .my, .top .total {
    display: flex;
    flex-flow: column;
    width: 1.1rem;
  }

  .top .dwz_box {
    position: relative;
    align-items: center;
  }
  .top .my{
    justify-content: center;
    align-items: flex-start;
    height: 1.1rem;
  }
  .top .total {
    justify-content: center;   
    align-items: flex-end;
    height: 1.1rem;    
  }

  .top .dwz_box .icon {
    display: flex;
    justify-content: center;
    flex-flow: column;
    align-items: center;
    width: 1.1rem;
    height: 1.1rem;
  }

  .top .dwz_box .icon img {
    width: 0.8rem;
    height: 0.8rem;
    z-index: 99;
  }
  .top .dwz_box .icon1 {
    width: 0.8rem;
    height: 0.32rem;
  }
  .top .dwz_box .icon1 img {
    width: 0.8rem;
    height: 0.32rem;
  }

  .top .my span, .top .total .span{
    text-align:left;
  }

  .top .my .txt , .top .total .txt{
    font-size: 0.12rem;
  }
  .top .my .money, .top .total .money {
    font-size: 0.24rem;
    margin: 0.04rem 0 0.08rem 0;
  }
  .top .my .today, .top .total .coin {
    font-size: 0.12rem;
  }

  .top .my .txt {
    position: relative;
  }

  .top .my .txt i {
    position: absolute;
    right: -0.4rem;
    top: -0.08rem;
    width: 0.38rem;
    height: 0.3rem;
  }
  .top .my .txt i img {
    width: 0.38rem;
    height: 0.3rem;
  }

  .top .total .coin {
    position: relative;
    padding-right: 0.14rem;
  }
  .top .total .coin i{
    position: absolute;
    width: 0.12rem;
    height: 0.12rem;
    right: 0;
    top: 0.02rem;
  }
  .top .total .coin i img{
    width: 0.12rem;
    height: 0.12rem;
  }

  /** 水波纹效果  start */
  .tips-click{
      width: 0.56rem;
      height: 0.56rem;
      position: absolute;
      cursor: pointer;
  }
  .tips-click span{
      color: #e69800;
      font-weight: bold;
      position: absolute;
      left: 50%;
      top: 48%;
      transform: translate(-50%,-50%);
      z-index: 2;
  }
  .tips-click b{
      width: 100%;
      height:100%;
      background: #fff;
      border-radius: 50%;
      display: block; 
      background-color: rgba(255, 255, 255, .6);  
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
  }
  .tips-click b:nth-of-type(1){
      -webkit-animation: click1 1s linear infinite;
      animation: click1 1s linear infinite;       
  }
  .tips-click b:nth-of-type(2){
      -webkit-animation: click2 1s linear infinite;
      animation: click2 1s linear infinite;       
  }
  @-webkit-keyframes click1 {
      0% {
          opacity: .8;
          -webkit-transform: scale(1);
          transform: scale(1);
      }
      100% {
          opacity: 0;
          -webkit-transform: scale(2);
          transform: scale(2);
      }
  }

  @keyframes click1 {
      0% {
          opacity: .8;
          -webkit-transform: scale(1);
          transform: scale(1);
      }
      100% {
          opacity: 0;
          -webkit-transform: scale(2);
          transform: scale(2);
      }
  }

  @-webkit-keyframes click2 {
      0% {
          opacity: .8;
          -webkit-transform: scale(1);
          transform: scale(1);
      }
      100% {
          opacity: 0;
          -webkit-transform: scale(3);
          transform: scale(3);
      }
  }

  @keyframes click2 {
      0% {
          opacity: .8;
          -webkit-transform: scale(1);
          transform: scale(1);
      }
      100% {
          opacity: 0;
          -webkit-transform: scale(3);
          transform: scale(3);
      }
  }

  /** 水波纹效果  end */


  /** 手指逐帧序列动画  start */
  .top .dwz_box .icon2 {
    position: absolute;
    z-index: 100;
    width: 0.45rem;
    height: 0.45rem;
    right: 0;
    bottom: 1.1rem;
  }
  .finger{
      display: block;
      width: 0.45rem;
      height: 0.45rem;
      background: url('~@/assets/images/finger/1.png') no-repeat;
      background-size: 0.45rem 0.45rem;
      -webkit-animation:run 2s steps(1) 0s infinite both;
      animation:run 2s steps(1) 0s infinite both;
  }

  @keyframes run {
    0% {
      background: url('~@/assets/images/finger/1.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    2%{
      background: url('~@/assets/images/finger/2.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    4%{
      background: url('~@/assets/images/finger/3.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    6%{
      background: url('~@/assets/images/finger/4.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    8%{
      background: url('~@/assets/images/finger/5.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    10%{
      background: url('~@/assets/images/finger/6.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    12%{
      background: url('~@/assets/images/finger/7.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    14%{
      background: url('~@/assets/images/finger/8.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    16%{
      background: url('~@/assets/images/finger/9.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    18%{
      background: url('~@/assets/images/finger/10.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    20%{
      background: url('~@/assets/images/finger/11.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    22% {
      background: url('~@/assets/images/finger/12.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    24%{
      background: url('~@/assets/images/finger/13.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    26%{
      background: url('~@/assets/images/finger/14.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    28%{
      background: url('~@/assets/images/finger/15.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    30%{
      background: url('~@/assets/images/finger/16.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    32%{
      background: url('~@/assets/images/finger/17.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    34%{
      background: url('~@/assets/images/finger/18.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    36%{
      background: url('~@/assets/images/finger/19.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    38%{
      background: url('~@/assets/images/finger/20.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    40%{
      background: url('~@/assets/images/finger/21.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    42%{
      background: url('~@/assets/images/finger/22.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    44% {
      background: url('~@/assets/images/finger/23.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    46%{
      background: url('~@/assets/images/finger/24.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    48%{
      background: url('~@/assets/images/finger/25.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    50%{
      background: url('~@/assets/images/finger/26.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    52%{
      background: url('~@/assets/images/finger/27.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    54%{
      background: url('~@/assets/images/finger/28.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    56%{
      background: url('~@/assets/images/finger/29.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    58%{
      background: url('~@/assets/images/finger/30.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    60%{
      background: url('~@/assets/images/finger/31.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    62%{
      background: url('~@/assets/images/finger/32.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    64%{
      background: url('~@/assets/images/finger/33.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    66% {
      background: url('~@/assets/images/finger/34.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    68%{
      background: url('~@/assets/images/finger/35.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    70%{
      background: url('~@/assets/images/finger/36.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    72%{
      background: url('~@/assets/images/finger/37.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    74%{
      background: url('~@/assets/images/finger/38.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    76%{
      background: url('~@/assets/images/finger/39.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    78%{
      background: url('~@/assets/images/finger/40.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    80%{
      background: url('~@/assets/images/finger/41.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    82%{
      background: url('~@/assets/images/finger/42.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    84%{
      background: url('~@/assets/images/finger/43.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    86%{
      background: url('~@/assets/images/finger/44.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    88%{
      background: url('~@/assets/images/finger/45.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    90%{
      background: url('~@/assets/images/finger/46.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    92%{
      background: url('~@/assets/images/finger/47.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
    94%{
      background: url('~@/assets/images/finger/48.png') no-repeat;
      background-size: 0.45rem 0.45rem;
    }
  }
  /** 手指逐帧序列动画  end */

  .main {
    display: block;
    width: 3.43rem;
    margin: 0 auto;
    position: relative;
    top: -0.64rem;
    overflow: hidden;
  }

  .block {
    display: block;
    width: 100%;
    background: #FFF;
    margin-bottom: 0.12rem;
    border-radius: 0.06rem;
    overflow: hidden;
  }

  /** 顶部任务模块 */
  .top_task {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.12rem;
  }
  .top_task .item{
    width: 1.08rem;
    height: 1.26rem;
    border-radius: 0.06rem;
    background: #FFFFFF;
    color:#333;
    display: flex;
    flex-flow: column;
    align-items: center;
  }

  .top_task .item .text {
    width: 0.9rem;
    text-align: center;
    font-size: 0.16rem;
    margin-top: 0.16rem;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow:ellipsis;
  }
  .top_task .item .desp {
    width: 0.9rem;
    text-align: center;
    margin-top: 0.02rem;
    font-size: 0.12rem;
    color:#999;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow:ellipsis;
  }

  .top_task .item .icon img {
    width: 0.8rem;
    height: 0.66rem;
  }

  /** 任务模块 */
  .m_task {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .m_task .item{
    height: 0.84rem;
    color:#333;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
  }
  .m_task .item .text {
    font-size: 0.12rem;
    margin-top: 0.08rem;
  }

  .m_task .item .icon img {
    width: 0.28rem;
    height: 0.28rem;
  }


  /** 卡券模块 */
  .m_card {
    display: flex;
    width: 3.11rem;
    padding: 0.16rem;
    justify-content: space-between;
  }
  .m_card .left {
    position: relative;
    padding-left: 0.24rem;
  }
  .m_card .left .title img  {
    width: 0.18rem;
    height: 0.16rem;
    position: absolute;
    left: 0;
    top: 0.02rem;
  }
  .m_card .left .title {
    font-size: 0.16rem;
    color: #333;
    line-height: 0.2rem;
    margin-right: 0.08rem;
  }
  .m_card .left .text {
    font-size: 0.14rem;
    color: #333;
  }
  .m_card .btn {
    font-size: 0.14rem;
    color: #FF7F4B;
  }

  /** banner */
  .my-swipe .van-swipe-item {
    line-height: 1.16rem;
    height: 1.16rem;
    text-align: center;
    border-radius: 0.06rem;
  }
  .my-swipe img {
    width: 3.43rem;
    height: 1.16rem;
  }

  /** 客服模块 */
  .kefu {
    display:flex;
    align-items: center;
    justify-content: center;
    margin: 0.16rem 0 0.24rem 0;
  }
  .kefu span {
    font-size: 0.12rem;
    color: #1F8FFF;
  }

  /** 今日推荐模块 */
  .task_tab {
    display:flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.06rem;
    border: 0.01rem solid #FF7F4B;
    color: #FF7F4B;
    font-size: 0.14rem;
    font-weight: 500;
  }

  .task_tab span {
    display:flex;
    width: 50%;
    align-items: center;
    justify-content: center;
    height: 0.36rem;
  }

  .task_tab span.active {
    color:#fff;
    background: #FF7F4B;
    border-radius: 0.04rem 0 0 0.04rem;
  }

 .task_list{
    display:flex;
    align-items: center;
    justify-content: center;
    width: 3.11rem;
    margin-top: 0.16rem;
    padding: 0.16rem;
    flex-flow: column;
 }

 .task_list .task_item {
   position: relative;
   display:flex;
   align-items: center;
   height: 0.86rem;
   justify-content: space-between;
   width: calc(3.11rem - 0.64rem);
   padding-left: 0.64rem;
 }

.task_list .task_item .icon img {
  width: 0.54rem;
  height: 0.54rem;
  border-radius: 0.06rem;
}

.task_list .task_item .icon {
  position: absolute;
  width: 0.54rem;
  height: 0.54rem;
  border-radius: 0.06rem;
  left: 0;
  top: 0.16rem;
}

 .task_list .task_item .left {
   display:flex;
   align-items: flex-start;
   flex-flow: column;
   justify-content: center;
 }

   .task_list .task_item .left .title {
    width: 1.6rem;
    font-size: 0.14rem;
    color: #333;
    margin-bottom: 0.04rem;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow:ellipsis;
 }
 .task_list .task_item .left .trial_info, .task_list .task_item .left .sub_title {
    width: 1.6rem;
    font-size: 0.12rem;
    color: #999;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow:ellipsis;
 }
 .task_list .task_item .right {
   display:flex;
   align-items: flex-end;
   flex-flow: column;
   justify-content: center;
 }
 .task_list .task_item .right .avg_money {
    font-size: 0.16rem;
    color: #FF7F4B;
    margin-bottom: 0.06rem;
    font-weight: 500;
 }

 .task_list .task_item .right .btn_txt {
    font-size: 0.14rem;
    color: #fff;
    border-radius: 0.14rem;
    width: 0.76rem;
    height: 0.28rem;
    line-height: 0.28rem;
    background: #FF7F4B;
    text-align:center;
 }

 /** 底部菜单模块 */
 .bottom_menu {
    display: block;
    width: 3.39rem;
    position: fixed;
    background-color: rgba(0, 0, 0, 0);
    padding: 0 0.18rem;
    bottom: 0;
    display:flex;
    background: #FFFFFF;
    box-shadow: 0 -2px 4px 0 rgba(0,0,0,0.03);
    justify-content: space-between;
    align-items: center;
  }
  .bottom_menu .bitem {
    display: flex;
    width: 0.48rem;
    height: 0.49rem;
    font-size: 0.12rem;
    color: #CCC;
    flex-flow: column;
    justify-content: center;
    align-items: center;
  }
  .bottom_menu .active {
    color: #FF7F4B;
  }
  .bottom_menu .icon img{
    width: 0.2rem;
    height: 0.2rem;
  }
  .bottom_menu .center img{
    width: 0.76rem;
    height: 0.64rem;
  }
</style>

<script>
import Loading from '@/components/Loading'
import { Dialog } from 'vant';

export default {
  created() {
    document.title = '乐乐赚首页预览'
    this.id = this.$route.query.id
    this.getConfig() // 获取首页页面配置
    this.taskList = this.getRandomArrayElements(this.taskList, 5);
  },
  components: {
    Loading
  },
  data() {
    return {
      id: 0,
      isLoad: false,
      bottomMenu: {},
      topMenu: {},
      topTask: {},
      mTask: {},
      card: {'num': 2, 'text': '卡券包'},
      taskList: [
        {
          'icon': 'http://s.tn990.com/game_try/admin/20200713/20200713093931482257.png',
          'title': '暴击联盟-2期',
          'sub_title': '试玩魔法场3局奖0.45元',
          'trial_info': '已有<span style="color:#ff7c08">79万+</span>人参与试玩',
          'avg_money': '人均20元+',
          'btn_txt': '马上赚'
        },
        {
          'icon': 'http://s.tn990.com/game_try/admin/20200618/20200618143649126953.png',
          'title': '至尊跑得快-2期',
          'sub_title': '累计赢取1万金币奖0.45元',
          'trial_info': '已有<span style="color:#ff7c08">69万+</span>人参与试玩',
          'avg_money': '人均19元+',
          'btn_txt': '马上赚'
        },
        {
          'icon': 'http://s.tn990.com/game_try/admin/20200708/20200708103106485315.png',
          'title': '勇者阿信-1期',
          'sub_title': '累计赚0.4元红包奖0.45元',
          'trial_info': '已有<span style="color:#ff7c08">39万+</span>人参与试玩',
          'avg_money': '人均29元+',
          'btn_txt': '马上赚'
        },
        {
          'icon': 'http://s.tn990.com/game_try/admin/20200717/20200717090634570889.png',
          'title': '别吃鸡-2期',
          'sub_title': '累计赢取1万金币奖0.45元',
          'trial_info': '已有<span style="color:#ff7c08">99万+</span>人参与试玩',
          'avg_money': '人均59元+',
          'btn_txt': '马上赚'
        },
        {
          'icon': 'https://xianwanimgs.oss-cn-hangzhou.aliyuncs.com/201906/636972525375961284.jpg',
          'title': '洪游3D捕鱼-13期',
          'sub_title': '一起来捕鱼吧！',
          'trial_info': '已有<span style="color:#ff7c08">30万+</span>人参与试玩',
          'avg_money': '人均30元+',
          'btn_txt': '马上赚'
        },
        {
          'icon': 'https://xianwanimgs.oss-cn-hangzhou.aliyuncs.com/corp-document/202006/09105100004.png',
          'title': '超级雷电-2期',
          'sub_title': '未来战争，由你主宰',
          'trial_info': '已有<span style="color:#ff7c08">20万+</span>人参与试玩',
          'avg_money': '人均15元+',
          'btn_txt': '马上赚'
        },
        {
          'icon': 'https://xianwanimgs.oss-cn-hangzhou.aliyuncs.com/201910/637064880484898192.jpg',
          'title': '西游战记-11期',
          'sub_title': '大师兄，师父被妖怪抓走了！',
          'trial_info': '已有<span style="color:#ff7c08">50万+</span>人参与试玩',
          'avg_money': '人均30元+',
          'btn_txt': '马上赚'
        },
        {
          'icon': 'http://s.tn990.com/game_try/admin/20200628/20200628162024655394.png',
          'title': '八向箭头-2期',
          'sub_title': '1分钟赚取0.45元',
          'trial_info': '已有<font color="#ff7c08">50万+</font>人参与试玩',
          'avg_money': '人均30元+',
          'btn_txt': '马上赚'
        },
        {
          'icon': 'https://xianwanimgs.oss-cn-hangzhou.aliyuncs.com/corp-document/201911/20141600004.jpg',
          'title': '捕鱼传奇-15',
          'sub_title': '超高爆率，分分钟变土豪!',
          'trial_info': '已有<span style="color:#ff7c08">150万+</span>人参与试玩',
          'avg_money': '人均15元+',
          'btn_txt': '马上赚'
        },
        {
          'icon': 'https://xianwanimgs.oss-cn-hangzhou.aliyuncs.com/201906/636971486143470977.jpg',
          'title': '爱玩斗地主-23期',
          'sub_title': '新用户玩3局7局有奖励~',
          'trial_info': '已有<span style="color:#ff7c08">500万+</span>人参与试玩',
          'avg_money': '人均30元+',
          'btn_txt': '立即试玩'
        },
        {
          'icon': 'https://xianwanimgs.oss-cn-hangzhou.aliyuncs.com/201910/637081444742242147.jpg',
          'title': '05·纵剑仙界-34期',
          'sub_title': '宝甲神兵齐护身，珍奇萌宠升阶助战~',
          'trial_info': '已有<span style="color:#ff7c08">1万+</span>人参与试玩',
          'avg_money': '人均10元+',
          'btn_txt': '立即试玩'
        },
        {
          'icon': 'http://file.market.xiaomi.com/thumbnail/PNG/l114/AppStore/013cf54dc160790bc23acd03e535af996ea43919a',
          'title': '步步赚',
          'sub_title': '随时随地遇见你',
          'trial_info': '已有<span style="color:#ff7c08">50万+</span>人参与试玩',
          'avg_money': '人均30元+',
          'btn_txt': '马上赚'
        }
      ]
    }
  },

  methods: {
    getRandomArrayElements(arr, count) {
        var shuffled = arr.slice(0), i = arr.length, min = i - count, temp, index;
        while (i-- > min) {
            index = Math.floor((i + 1) * Math.random());
            temp = shuffled[index];
            shuffled[index] = shuffled[i];
            shuffled[i] = temp;
        }
        return shuffled.slice(min);
    },
    getMenuClass: function (key) {
      if (key == 0) {
        return 'menu_item dwz';
      }
      return 'menu_item'
    },
    getTMenuClass: function (key) {
      if (key == 0) {
        return 'bitem active';
      } else if (key == 2) {
        return 'bitem center';
      }
      return 'bitem'
    },
    getConfig: function () {
      if (!this.id) {
        Dialog({ message: '参数错误' });
      }
      this.isLoad = true
      // let host = 'http://gametest.lushihudong.com'
      let host = ''
      let params = {
        id: this.id,
      }

      this.isLoad = true
      this.$http.get(host + '/api/user_web/get_home_page_set', {params: params}).then((res) => {
        if (res.code == 0) {
          Dialog({ message: res.message });
          return false;
        }
        this.isLoad = false
        let data = res.data
        
        this.bottomMenu = data.menu_config.list
        this.topMenu = data.menu_config.list[0].son_page
        this.topTask = data.page_config[1].pages
        this.mTask = data.page_config[3].pages

      })
    },
  }
}
</script>